import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
//ReactDOM.render(<App />, document.getElementById("root"));

// frame busting in case we miss a link somewhere
if (self != top) top.location = self.location;

// TODO: this goes away!
// listen for invalidation messages from iframes
window.addEventListener(
    "message",
    event => {
        const { invalidate: { accountID } = {}, path } = event.data;
        //const navigate = useNavigate();
        if (accountID) {
            console.log(accountID);
            //navigate(accountID);
        }
        if (path) {
            console.log(path);
            //navigate(path);
        }
    },
    false
);
